import React from 'react';

const AssignmentActionDetails = ({ assignmentActions, currentVehicleType = null }) => {
  if (!assignmentActions || assignmentActions.length === 0) {
    return null;
  }

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Kolkata'
    });
  };

  return (
    <div className="w-[99%] p-5 bg-white borderStyle">
      <h3 className="font-semibold font-[16px] text-[#414D55] mb-4">
        Assignment History
      </h3>
      
      <div className="space-y-4">
        {assignmentActions.map((action, index) => (
          <div 
            key={index} 
            className="bg-gray-50 rounded-lg p-4 border border-gray-100 hover:shadow-md transition-shadow duration-200"
          >
            {/* Header with timestamp and upgrade indicator */}
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs font-medium text-[#969696]">
                {formatTimestamp(action.timestamp)}
              </span>
              {action.isUpgrade && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gradient-to-r from-green-500 to-green-600 text-white">
                  UPGRADE
                </span>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Assignment Reason */}
              <div className="space-y-0.3">
                <h4 className="text-sm font-medium text-[#969696] tracking-wide">
                  Assignment Reason
                </h4>
                <p className="text-sm"
                title={action.reason?.category}
                >
                  {action.reason?.category || 'N/A'}
                </p>
                {action.reason?.comments && (
                  <p className="text-xs text-gray-600 truncate max-w-xs"
                  title={action.reason.comments}
                  >
                    Comments: {action.reason.comments}
                  </p>
                )}
              </div>

              {/* Assigned By */}
              <div className="space-y-0.3">
                <h4 className="text-sm font-medium text-[#969696] tracking-wide">
                  Assigned By
                </h4>
                <p className="text-sm">
                  {action.assignedByName || 'System'}
                </p>
              </div>
            </div>

            {/* Vehicle Upgrade Information */}
            {action.isUpgrade && action.previousVehicle && (
              <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-3">
                <h4 className="text-xs font-medium colorGrey mb-2 tracking-wide">
                  Vehicle Upgrade Details
                </h4>
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <span className="text-xs text-gray-600">From:</span>
                    <span className="text-sm font-medium text-gray-900">
                      {action.previousVehicle.type || 'Not specified'}
                    </span>
                  </div>
                  <div className="text-blue-600 font-bold text-lg">
                    →
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-xs text-gray-600">To:</span>
                    <span className="text-sm font-medium text-blue-700">
                      {currentVehicleType || 'Current Vehicle'}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Previous Driver Info */}
            {action.previousDriver && (
              <div className="mt-3 pt-3 border-t border-gray-200">
                <p className="text-xs text-gray-600">
                  <span className="font-medium">Previous Driver:</span> {action.previousDriverName}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssignmentActionDetails;
